var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable no-return-await */
import axios from 'axios';
import { EAxiosMethod } from '../types/api';
import { ELocalStorageKeys } from '../types/auth';
const baseURL = process.env.API_URL || '/api';
console.log(baseURL);
// Ни один запрос ведущего не должен висеть дольше: без таймаута
// подвисшая ручка оставляет экран в вечном скелетоне без ошибки.
const REQUEST_TIMEOUT_MS = 20000;
const LOGIN_PATH = '/login';
// Ручки логина сами сообщают о неверном коде — их 401 не должен разлогинивать.
const AUTH_PATH_PREFIX = '/v1/auth/';
const callApi = ({ method, path, data, params = {}, headers = {} }) => __awaiter(void 0, void 0, void 0, function* () {
    const config = {
        baseURL,
        url: path,
        method: method || EAxiosMethod.GET,
        params,
        data,
        timeout: REQUEST_TIMEOUT_MS,
        headers: Object.assign(Object.assign(Object.assign({}, axios.defaults.headers.common), { 'Content-Type': 'application/json' }), headers),
    };
    // console.log('api.callApi config', config)
    const response = yield axios(config);
    return response.data;
});
export const get = ({ path, params, data, headers }) => __awaiter(void 0, void 0, void 0, function* () { return yield callApi({ method: EAxiosMethod.GET, path, params, headers, data }); });
export const post = ({ path, data, params, headers }) => __awaiter(void 0, void 0, void 0, function* () { return yield callApi({ method: EAxiosMethod.POST, path, data, params, headers }); });
export const put = ({ path, data, params, headers }) => __awaiter(void 0, void 0, void 0, function* () { return yield callApi({ method: EAxiosMethod.PUT, path, data, params, headers }); });
export const del = ({ path, params, headers }) => __awaiter(void 0, void 0, void 0, function* () { return yield callApi({ method: EAxiosMethod.DELETE, path, params, headers }); });
export const setAccessToken = (token) => __awaiter(void 0, void 0, void 0, function* () {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
});
export const removeAccessToken = () => {
    delete axios.defaults.headers.common.Authorization;
};
let isRedirectingToLogin = false;
/**
 * Протухший токен остаётся в localStorage, поэтому страница, не умеющая
 * обработать 401, зацикливается на пустом экране: перезагрузка подставляет
 * тот же мёртвый токен. Чистим его и уводим на логин из одного места,
 * чтобы это не зависело от того, какая страница поймала 401.
 */
const handleUnauthorized = (requestUrl) => {
    if (requestUrl === null || requestUrl === void 0 ? void 0 : requestUrl.startsWith(AUTH_PATH_PREFIX))
        return;
    if (isRedirectingToLogin)
        return;
    isRedirectingToLogin = true;
    localStorage.removeItem(ELocalStorageKeys.TOKEN);
    removeAccessToken();
    if (window.location.pathname !== LOGIN_PATH) {
        window.location.replace(LOGIN_PATH);
    }
};
axios.interceptors.response.use((response) => response, (error) => {
    var _a, _b;
    if (axios.isAxiosError(error) && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
        handleUnauthorized((_b = error.config) === null || _b === void 0 ? void 0 : _b.url);
    }
    return Promise.reject(error);
});
